import { combineReducers } from 'redux';

// -> REDUCERS <- \\

// -> REDUCERS <- \\

const reducers = combineReducers({});

export default reducers;
